module.exports = __webpack_public_path__ + "static/media/1.4_preview.7657cda4.png";